import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import 'ace-builds/src-noconflict/mode-javascript'

import { EditorWidget } from './EditorWidget'

export const EditorJavascriptWidget: React.FC<WidgetProps> = props => {
  return <EditorWidget mode={'javascript'} {...props} />
}
